import { render, staticRenderFns } from "./travelPhoto.vue?vue&type=template&id=0aece6fb&scoped=true&lang=html&"
import script from "./travelPhoto.vue?vue&type=script&lang=js&"
export * from "./travelPhoto.vue?vue&type=script&lang=js&"
import style0 from "./travelPhoto.vue?vue&type=style&index=0&id=0aece6fb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aece6fb",
  null
  
)

export default component.exports